import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const dockerRegistry = defineConnector({
  identifier: "dockerRegistry",
  name: "Docker Registry",
  tagLine: "OCI image distribution",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: ({ url }) =>
    url ? `${url}/.*` : "https://registry.example.com/.*",
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Create or collect a registry bearer token",
      items: [
        {
          kind: "markdown",
          content:
            "Follow the official docs at [https://distribution.github.io/distribution/spec/auth/token/](https://distribution.github.io/distribution/spec/auth/token/) and [https://distribution.github.io/distribution/spec/api/](https://distribution.github.io/distribution/spec/api/). This draft assumes you already have a registry bearer token and sends it as `Authorization: Bearer <token>`.",
        },
      ],
    },
    {
      title: "Enter your connection details",
      items: [
        {
          kind: "url",
          label: "Docker Registry base URL",
          placeholder: "https://registry.example.com",
          required: true,
          target: { kind: "configuration", field: "url" },
        },
        {
          kind: "input",
          label: "Bearer token",
          required: true,
          target: {
            kind: "secrets",
            field: "accessToken",
          },
        },
        {
          kind: "test-url",
          label: "Test URL",
          placeholder: "https://registry.example.com/health",
          helperText:
            "Optional. Set this if you want testing to hit a specific endpoint instead of the default draft URL.",
          urlTarget: {
            kind: "configuration",
            field: "testUrl",
          },
          methodTarget: {
            kind: "configuration",
            field: "testMethod",
          },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ testUrl, testMethod, ...configuration }) => ({
      url: testUrl ?? (({ url }) => `${url}/v2/`)(configuration),
      method: testMethod === "POST" ? "POST" : "GET",
    }),
  },
});
